import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode:'history',
  base: 'h5',
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('@/views/DownloadApp')
    },
    {
      path: '/live',
      name: 'Live',
      component: () => import('@/views/Live')
    },
    {
      path: '/doc',
      name: 'Doc',
      component: () => import('@/views/Doc')
    },
    {
      path: '/pdf',
      name: 'Pdf',
      component: () => import('@/views/Pdf')
    },
    // Article
    {
      path: '/article',
      name: 'Article',
      component: () => import('@/views/Article/index')
    },
    // Video
    {
      path: '/video',
      name: 'Video',
      component: () => import('@/views/Video/indexnew')
    },
    // Download
    {
      path: '/download-app',
      name: 'DownloadApp',
      component: () => import('@/views/DownloadApp')
    },
      // Download
    {
      path: '/download',
      name: 'DownloadPage',
      component: () => import('@/views/DownloadApp/download')
    },
    {
      path: '/course-detail',
      name: 'CourseDetail',
      component: () => import('@/views/CourseDetail')
    },
    // Course
    {
      path: '/course',
      name: 'Course',
      component: () => import('@/views/Course')
    },
     // Course
    {
      path: '/course-h5',
      name: 'CourseH5',
      component: () => import('@/views/CourseH5')
    },
    // Sleep
    {
      path: '/sleep',
      name: 'Sleep',
      component: () => import('@/views/Sleep')
    },
    {
      path: '/topic',
      name: 'Topic',
      component: () => import('@/views/Topic')
    },
    {
      path: '/section',
      name: 'Section',
      component: () => import('@/views/Section')
    },
    {
      path: '/page',
      name: 'Page',
      component: () => import('@/views/InformationDetail')
    },
    {
      path: '/note',
      name: 'Note',
      component: () => import('@/views/InformationDetail')
    },
    {
      path: '/information-detail',
      name: 'InformationDetail',
      component: () => import('@/views/InformationDetail')
    },
    {
      path: '/healthy-circle-detail',
      name: 'HealthyCircleDetail',
      component: () => import('@/views/HealthyCircleDetail')
    },
    {
      path: '/live-course-package-detail',
      name: 'LiveCoursePackageDetail',
      component: () => import('@/views/LiveCoursePackageDetail')
    },
    {
      path: '/course-package-detail',
      name: 'CoursePackageDetail',
      component: () => import('@/views/CoursePackageDetail')
    },
    {
      path: '/healthy-test-detail',
      name: 'HealthyTestDetail',
      component: () => import('@/views/HealthyTestDetail')
    },
    {
      path: '/inquiry-Detail',
      name: 'InquiryTCMDetail',
      component: () => import('@/views/InquiryTCMDetail')
    },
    // {
    //   path: '/sickness-detail',
    //   name: 'SicknessDetail',
    //   component: () => import('@/views/SicknessDetail')
    // },
    // {
    //   path: '/symptom-detail',
    //   name: 'SymptomDetail',
    //   component: () => import('@/views/SymptomDetail')
    // },
    {
      path: '/drug-detail',
      name: 'DrugDetail',
      component: () => import('@/views/DrugDetail')
    },
    {
      path: '/sickness-symptom-detail',
      name: 'SicknessOrSymptomDetail',
      component: () => import('@/views/SicknessOrSymptomDetail')
    },
    {
      path: '/present-course', // presentation-detail
      name: 'PresentCourse',
      component: () => import('@/views/PresentCourse')
    },
    {
      path: '/activity-project-detail',
      name: 'ActivityProject',
      component: () => import('@/views/ActivityProject')
    },
    {
      path: '/promotion-activity',
      name: 'PromotionActivity',
      component: () => import('@/views/ActivitySqueezePage/PromotionActivity')
    },
    {
      path: '/promotion-success',
      name: 'ApplySuccess',
      component: () => import('@/views/ActivitySqueezePage/ApplySuccess')
    },
    {
      path: '/course-list',
      name: 'CourseList',
      component: () => import('@/views/CourseList')
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js